import { discountSettingsSchema } from "@redotech/redo-model/discount/discount-db-parser";
import { TrackingPageDiscountSource } from "@redotech/redo-model/generated-discount-code-definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const generateDiscountCode = {
  name: "generateDiscountCode" as const,
  input: z.object({
    discountId: zExt.objectId(),
    orderId: z.string().optional(),
    source: createEnum(TrackingPageDiscountSource),
  }),
  output: z.object({
    discountCode: z.string(),
    discountSettings: discountSettingsSchema.optional(),
  }),
};
